export default __webpack_public_path__ + "static/media/Arch_AWS-WAF_64.0be62545.svg";